import { API } from "@lib/services/http";
import { AuthUser } from "@lib/types/Auth";
import { AxiosResponse } from "axios";

export const apiAuthSignin = async (data: {
  username: string;
  password: string;
  twoFactorAuthenticationCode?: string;
}): Promise<AxiosResponse<AuthUser>> => {
  const url = `/payment-hub-auth/login`;
  return API.post(url, data);
};

export const apiAuthTwoFactorCreate = async () => {
  const url = `/payment-hub-2fa/generate`;
  return API.post<any>(url, {}, { responseType: "blob" });
};

export const apiAuthTwoFactorTurnOn = async () => {
  const url = `/payment-hub-2fa/turn-on`;
  return API.post<any>(url);
};

export const apiAuthTwoFactorTurnOff = async (id: string) => {
  const url = `/payment-hub-2fa/turn-off/${id}`;
  return API.post<any>(url);
};
